<template>
  <div>
    <div class="banner"></div>
    <Menubar></Menubar>
    <article>
      <router-view></router-view>
    </article>
  </div>
</template>

<script>
import Menubar from "./Menubar";

export default {
  mounted() {
    if (this.$route.path === "/aboutus") {
      this.$router.push("/aboutus/profile");
    }
  },

  components: { Menubar }
};
</script>

<style lang="scss" scoped>
.banner {
  background: url(../../assets/images/aboutus/banner.png) no-repeat center;
  background-size: cover;
  height: 40vh;
  opacity: 0.95;
}

// 没用
// ::v-deep .footer {
//   margin-top: 0 !important;
// }

article {
  display: flex;
  flex-direction: column;
  align-items: center;

  > section {
    display: flex;
    flex-direction: column;

    > .caption {
      text-align: center;
      padding-bottom: 30px;

      > span {
        font-size: 9px;
        color: #b3b3b3;
      }
    }
  }
}
</style>